interface StockAwareVariant {
  tracked?: boolean;
  stock?: number;
  allowBackorders?: boolean;
}

/**
 * Upper quantity limit for a variant, or `undefined` when the quantity is unlimited.
 * Backorders are unlimited even on stock-tracked variants.
 */
export function getMaxOrderQuantity(variant?: StockAwareVariant | null): number | undefined {
  if (!variant?.tracked || variant.allowBackorders) return undefined;

  return typeof variant.stock === 'number' && variant.stock > 0 ? variant.stock : undefined;
}
